import { render, staticRenderFns } from "./company-departments.vue?vue&type=template&id=ba512bc0"
import script from "./company-departments.vue?vue&type=script&lang=js"
export * from "./company-departments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports